import {useEffect, useState} from 'react';
import {storageService} from '../../../services/storageService';
import {_SYSTEM_TITLES, InsightsType} from '../../../configuration/index.config';

const useAccuracy = ({isShowToolTip, accuracy, insights }) => {
    const [isClicked, setIsClicked] = useState(false);
    const [toolTipTitle, setToolTipTitle] = useState('');
    const checkIfCanShowInsights = () => insights.length > 0 &&
        'insight_type' in insights[0] &&
        insights[0].insight_type !== 'no_insights' &&
        insights[0].insight_type !== 'no_evaluation_data' &&
        insights[0].insight_type !== 'accuracy_error' &&
        insights[0].insight_type !== 'accuracy_in_progress';

    /**
     * openInsights - open or close insights pop up
     * @param e - click event
     */
    const openInsights = (e) => {
        e.preventDefault();
        e.stopPropagation();
        isClicked ? storageService.removeFromStorage('isOpenInsights') : storageService.saveToStorage('isOpenInsights', true);
        setIsClicked(!isClicked);
    };

    useEffect(() => {
        if (insights.length > 0) {
            setIsClicked(false);

            const toolTipRegular = !checkIfCanShowInsights() ? _SYSTEM_TITLES[InsightsType[insights[0].insight_type]] : _SYSTEM_TITLES.trainingInsightsToolTip;

            isShowToolTip && setToolTipTitle(accuracy === 'N/A' ? _SYSTEM_TITLES[InsightsType[insights[0].insight_type]] : toolTipRegular);
        }

    }, []);

    return {
        isClicked,
        openInsights,
        toolTipTitle,
        checkIfCanShowInsights
    };
};

export default useAccuracy;
